import React, { FC } from "react";
import { ADMIN_MAINTENANCE_REVENUE } from "../graphql";
import { RevenueDetailPage } from "./RevenueDetailPage";

export const MaintenanceRevenuePage: FC = () => {
  return (
    <RevenueDetailPage
      title="Maintenance revenue"
      description="Revenue from facility maintenance requests."
      query={ADMIN_MAINTENANCE_REVENUE}
      queryRootField="adminMaintenanceRevenue"
    />
  );
};
